export const checkedRadioStyles = {
  _before: {
    content: '""',
    display: 'inline-block',
    width: '7px',
    height: '7px',
    borderRadius: '50%',
    background: 'black',
  },
  _checked: {
    borderColor: 'black',
    color: 'black',
    boxShadow: 'none',
  },
};
export const versionCheckedRadioStyles = {
  _before: {
    content: '""',
    display: 'inline-block',
    width: '7px',
    height: '7px',
    borderRadius: '50%',
    background: '#4BB6B9;',
  },
  _checked: {
    borderColor: '#4BB6B9;',
    color: '#4BB6B9;',
    boxShadow: 'none',
  },
};

export const textStyles = {
  fontSize: '0.9rem',
  fontFamily: 'regular_roboto',
  fontWeight: '400',
};

export const MONTH_NAME_TO_INDEX: Record<string, number> = {
  jan: 0,
  january: 0,
  feb: 1,
  february: 1,
  mar: 2,
  march: 2,
  apr: 3,
  april: 3,
  may: 4,
  jun: 5,
  june: 5,
  jul: 6,
  july: 6,
  aug: 7,
  august: 7,
  sep: 8,
  sept: 8,
  september: 8,
  oct: 9,
  october: 9,
  nov: 10,
  november: 10,
  dec: 11,
  december: 11,
};

export const MULTI_INDICATOR_TYPE = {
  ROW: 'row',
  COLUMN: 'column',
} as const;

export const DATA_PERIOD = {
  SINGLE: '1',
  MULTIPLE: '2',
} as const;

export const IMPORT_INDICATOR_TYPE = {
  MULTIPLE: '2',
} as const;

export const TIME_MAPPING_TYPE = {
  ROW: 'row',
  COLUMN: 'column',
} as const;

export const DATA_TYPE = {
  DATA: '1',
  ACTUAL: '2',
  FORECAST: '3',
} as const;

export const ACTION_TYPE = {
  DATA: 'data',
  FORECAST: 'forecast',
} as const;
